import { render, staticRenderFns } from "./purchase-method-item.vue?vue&type=template&id=4312bc3d&scoped=true&"
import script from "./purchase-method-item.vue?vue&type=script&lang=js&"
export * from "./purchase-method-item.vue?vue&type=script&lang=js&"
import style0 from "./purchase-method-item.vue?vue&type=style&index=0&id=4312bc3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312bc3d",
  null
  
)

export default component.exports